<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="公告标题：">
				<el-input clearable v-model="formInline.title" size="small" placeholder="请输入公告标题" @keyup.enter.native="search"></el-input>
			</el-form-item>
			<el-form-item label="起止日期：">
				<el-date-picker
					v-model="chooseTime"
					size="small"
					type="daterange"
					range-separator="至"
					start-placeholder="开始时间"
					end-placeholder="结束时间"
					value-format="yyyy-MM-dd"
					@change="changeTime"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" class="el-icon-search" @click="search()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</el-form-item>
			<el-form-item style="float: right; margin-right: 0">
				<el-button v-if="isEdit" size="small" type="primary" class="el-icon-plus" @click="handleAdd()">新增</el-button>
				<!-- <el-button size="small" plain icon="el-icon-search">高级筛选</el-button> -->
				<my-column-filter :list-columns="listColumns" @hide-pop="getCheckBox"></my-column-filter>
			</el-form-item>
		</el-form>
		<!--列表-->
		<STable :columns="columnsData" :data="listData" :loading="loading" :row-key="'keyId'" @get-data="getListData" @handle-operation="handleRowClick">
			<template #title>
				<el-table-column prop="title" label="公告标题" show-overflow-tooltip>
					<template #default="scope">
						<span class="down_btn" @click.stop="seeDetail(scope.row)">{{ scope.row.title }}</span>
					</template>
				</el-table-column>
			</template>
			<template #isShow>
				<el-table-column align="center" prop="isShow" label="是否显示">
					<template #default="scope">
						<span @click.stop.prevent>
							<el-switch v-model="scope.row.isShow" :disabled="!isEdit" active-color="#13ce66" inactive-color="" @change="editIsShow(scope.row)"></el-switch>
						</span>
					</template>
				</el-table-column>
			</template>
			<template #isTop>
				<el-table-column align="center" prop="isTop" label="是否置顶">
					<template #default="scope">
						<span @click.stop.prevent>
							<el-switch v-model="scope.row.isTop" :disabled="!isEdit" active-color="#13ce66" inactive-color="" @change="editIsTop(scope.row)"></el-switch>
						</span>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetSystemNoticeList, UpdateSystemNoticeShow, UpdateSystemNoticeTop } from "../../../api/systemApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			expandAll: true,
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				title: ""
			},
			listData: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					slot: "title",
					label: "公告标题",
					isKeep: true
				},
				{
					prop: "startTime",
					label: "开始时间"
				},
				{
					prop: "endTime",
					label: "结束时间"
				},
				{
					slot: "isShow",
					label: "是否展示"
				},
				{
					slot: "isTop",
					label: "是否置顶"
				},
				{
					prop: "content",
					label: "公告内容"
				},
				{
					operationC: true,
					label: "操作",
					isKeep: true
				}
			],
			isEdit: true,
			chooseTime: ""
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		if (this.$route.query.data) {
			this.isEdit = false;
			// this.formInline.title = this.$route.query.data;
		} else {
			this.isEdit = true;
		}

		this.getListData();
	},
	mounted() {
		if (this.$route.query.rowData) {
			this.$emit("clickCard", JSON.parse(this.$route.query.rowData), 1);
		}
	},
	computed: {},
	methods: {
		changeTime(val) {
			if (val !== null) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.getListData();
		},
		// 跳转详情
		seeDetail(row) {
			this.$emit("clickCard", row, 1);
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},

		// 点击新增
		handleAdd() {
			this.$refs.edit.editShow();
		},

		// 单击行数据
		handleRowClick(row) {
			if (this.isEdit) {
				this.$refs.edit.editShow(row);
			}
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.chooseTime = [];
			this.search();
		},

		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

		// 获取列表
		getListData() {
			this.listData = [];
			this.loading = true;
			GetSystemNoticeList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 设置是否显示
		editIsShow(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isShow
			};
			UpdateSystemNoticeShow(param)
				.then((res) => {
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		// 设置是否置顶
		editIsTop(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isTop
			};
			UpdateSystemNoticeTop(param)
				.then((res) => {
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>

<style scoped>
/deep/ .el-switch__core {
	width: 40px !important;
}
</style>
